import React from 'react'

const Error = () => {
  return (
    <div className='flex mx-auto text-3xl text-white'>
      Error - 404 Not Found
    </div>
  )
}

export default Error
